import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SharedDataService {
  private sharedDataSource = new BehaviorSubject<any>({});

  sharedData = this.sharedDataSource.asObservable();

  constructor() {}

  addSharedData(sharedData: any) {
    this.sharedDataSource.next(sharedData);
  }
  
}
